<template>
  <div id="Wrapper">
    <div id="Title" style="margin-bottom: 10px;">
      <img width="128" height="128" alt="Vue logo" src="./assets/logo.webp">
      <span id="LogoutBtn" @click="Logout">Logout</span>
      <div v-if="EnvCheck === 'development'">
        <div style="background-color: red; color: white; border-radius: 10px; display: inline-block; padding: 5px 10px; cursor: pointer;" @click="OpenAccountReg">アカウント登録</div>
      </div>
    </div>
    <div style="margin-bottom: 4px;">
      <span id="AppInfo">お客様の会話は、このサービスの改善のために使用されることをご了承ください。</span>
    </div>
    <div v-if="ShowAccountReg" id="AccountReg">
      <div style="width: 100vw; height: 100vh; background-color: rgba(10,10,10,0.7); display: grid;">
        <div style="place-self: center; background-color: antiquewhite; width: 400px; height: 300px; border-radius: 10px; display: flex; flex-direction: column">
          <div style="background-color: green; border-top-left-radius: 10px; border-top-right-radius: 10px; color: white; font-size: 120%; padding: 10px 0px;">
            Account registration <span style="float: right; width: 20px; height: 20px; background-color: red; cursor: pointer; padding: 4px;" @click="CloseAccountReg">X</span>
          </div>
          <div style="display: grid; place-self: center; place-content: center; flex: 1; width: 100%;">
            <div>
              <label>Email</label><br>
              <input id="email" />
            </div>
            <div style="margin-top: 20px;">
              <label>Password</label><br>
              <input id="password" type="password"/>
            </div>
            <div style="margin-top: 20px;">
              <label>Key</label><br>
              <input id="key" />
            </div>
            <div>
              <div style="margin-top: 20px; background-color: red; color: white; border-radius: 10px; display: inline-block; padding: 5px 10px; cursor: pointer;" @click="SendRegRequest">
                Register
              </div>
            </div>
            <div style="margin-top: 10px;" :class="{NewUserSuccess: RegistrationSuccess === true, NewUserFail: RegistrationSuccess === false}">
              {{ RegistrationResponse }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <UserLogin v-if="IsLoggedIn === false" :SendLoginRequest="Login" />
    <ChatHistory :Messages="Messages" :IsResponding="IsWaitingForAI" :-feedback-callback="OnBadResponseRating" />
    <div id="InputContainer">
      <label>入力：</label>
      <input id="UserInput" v-model="UserPrompt" />
    </div>
    <div>
      <div v-if="IsWaitingForAI === false" id="SubmitButton" class="Button Transition" style="width: 100px; margin-bottom: 20px; font-size: 18px;" @click="SendPrompt">
        Send
      </div>
      <div v-else>
        <div class="lds-ripple"><div></div><div></div></div>
      </div>
    </div>
    <div id="SendFeedbackInfo">
      AIの返信は上手く出来ませんでした、申し訳ございません🙇。<br>
      そのフェードバックで改善することが出来ます、ありがとうございます。
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ChatHistory from './components/ChatHistory.vue';
import UserLogin from './components/UserLogin.vue';

export default {
  name: 'App',
  components: {
    ChatHistory,
    UserLogin,
  },
  mounted(){
    // Check first if we are logged in already
    const token = this.$GetToken();
    console.log('stored token', token);
    console.log('stored user', this.$GetUser());
    console.log('stored userID', this.$GetUserID());
    this.IsLoggedIn = token !== null;
    if (this.IsLoggedIn === true)
    {
      this.GetChatHistory();
    }

    const inp = document.getElementById('UserInput');
    inp.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' &&
            event.target.value.trim() !== '')
        {
            this.SendPrompt();
        }
    });
  },
  computed:{
    EnvCheck()
    {
      console.log('environment',process.env.VUE_APP_ENV);
      return process.env.VUE_APP_ENV;
    }
  },
  methods:{
    Logout()
    {
      this.$ClearAll();
      window.location.reload();
    },
    OpenAccountReg()
    {
      this.ShowAccountReg = true;
    },
    CloseAccountReg()
    {
      this.ShowAccountReg = false;
    },
    async OnBadResponseRating(msgID)
    {
      if (msgID === null ||
          msgID === undefined ||
          msgID === -1)
      {
        console.log('[App](OnBadResponseRating) no msgID');
        return;
      }

      const param = {
          SessionToken: this.$GetToken(),
          UserID: this.$GetUserID(),
          MessageID: msgID,
      };

      let ratingResponse = await axios.post(`${process.env.VUE_APP_BACKEND_URL}nippo/badresponse`, param)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error when sending bad-rating', error);
      })

      if (ratingResponse.affectedRows !== 0)
      {
        this.ShowFeedbackSent(`
          AIの返信は上手く出来ませんでした、申し訳ございません🙇。<br>
          そのフェードバックで改善することが出来ます、ありがとうございます。
        `);
      }
      else
      {
        this.ShowFeedbackSent(`
          そのメッセージはもうフェードバックあります。🙇
        `);
      }
      console.log('rating response', ratingResponse);
    },
    ShowFeedbackSent(message)
    {
      const el = document.getElementById('SendFeedbackInfo');
      if (el !== null)
      {
        el.innerHTML = message;
        el.style.opacity = 1;
        el.style.top = '30%';

        setTimeout(()=>{
          el.style.opacity = 0;
          el.style.top = '35%';
        }, 3000);
      }
    },
    async SendRegRequest()
    {
      const data = {
        email: document.getElementById('email').value,
        pw: document.getElementById('password').value,
        key: document.getElementById('key').value,
      };
      const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}nippo/acc/register`, data)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return null;
      });

      console.log('created', result);
      if (result.status === 201)
      {
        this.RegistrationSuccess = true;
        this.RegistrationResponse = `${data.email} registered successfully`;
        document.getElementById('email').value = '';
        document.getElementById('password').value = '';
      }
      else
      {
        this.RegistrationSuccess = false;
        this.RegistrationResponse = `${data.email} no registered`;
        console.log('reg error', result);
      }
    },
    async Login(mail, password)
    {
      const data = {
        email: mail,
        password: password
      };

      console.log('Send login request', `${process.env.VUE_APP_BACKEND_URL}nippo/login`);
      const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}nippo/login`, data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('login error', error);
        return null;
      });

      this.$SetToken(result.Token);
      this.$SetUser(result.Email);
      this.$SetUserID(result.UserID);
      this.IsLoggedIn = true;
      this.GetChatHistory();
      console.log('Set user ID: ' + this.$GetUserID(), result.UserID);
    },
    async GetChatHistory()
    {
        const param = {
            SessionToken: this.$GetToken(),
            UserID: this.$GetUserID(),
        };

        console.log('Get chat history data', param);

        let chatHistory = await axios.post(`${process.env.VUE_APP_BACKEND_URL}nippo/chat`, param)
        // let chatHistory = await axios.post(`http://${window.location.hostname}:3001/nippo/chat`, param)
        .then(response => {
          // ShowLoading(false);
          return response.data;
        })
        .catch(error => {
          // ShowLoading(false);
          // if (error.response.status != 500)
          // {
          //     this.$HandleBadRequest(error.response.status, error.response.data);
          // }
          console.log('Error when trying to receive chat history', error);

          if (error.request.response === "1" ||
              error.request.response === "2")
          {
            this.IsLoggedIn = false;
          }
          return null;
        });

        if (chatHistory === null ||
            chatHistory.history === null)
        {
          console.log('No chat history', chatHistory);
          return;
        }

        console.log('Chat history', chatHistory);
        this.Messages = chatHistory.history;

        this.$nextTick(()=>{
          this.ScrollChatToBottom();
        })
    },
    async SendPrompt()
    {
      if (this.IsWaitingForAI === true)
      {
        return;
      }

      this.IsWaitingForAI = true;
      const submitBtn = document.getElementById('SubmitButton');
      submitBtn.classList.add('Disabled');

      this.AppendUserMessage(this.UserPrompt);

      this.$nextTick(()=>{
        this.ScrollChatToBottom();
      });

      const data = {
        SessionToken: this.$GetToken(),
        UserID: this.$GetUserID(),
        UserMessage: this.UserPrompt,
      };

      this.UserPrompt = '';

      // console.log('[SendPrompt] URL', `${process.env.VUE_APP_BACKEND_URL}nippo/analyze`);
      //console.log('[SendPrompt] URL', `http://${window.location.hostname}:3001/nippo/analyze`);
      console.log('[SendPrompt] data', data);

      let result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}nippo/analyze`, data)
      //const result = await axios.post(`http://${window.location.hostname}:3001/nippo/analyze`, data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('Analyzation error', error);
        
        if (error.request.response === "1" ||
            error.request.response === "2")
        {
          this.IsLoggedIn = false;
        }
        return error.response.data;
      });

      submitBtn.classList.remove('Disabled');
      this.IsWaitingForAI = false;

      console.log('Analyze result', result);

      this.AppendAIMessage(result.Answer);
      
      this.$nextTick(()=>{
        this.ScrollChatToBottom();
      });
    },
    AppendUserMessage(input)
    {
      this.Messages.push({
        role: 'user',
        content: input
      });
      
      this.ScrollChatToBottom();
    },
    AppendAIMessage(input)
    {
      this.Messages.push({
        role: 'ai',
        content: input
      });

      this.ScrollChatToBottom();
    },
    ScrollChatToBottom()
    {
        const chatHistory = document.getElementById('ChatWrapper');
        chatHistory.scrollTop = chatHistory.scrollHeight;
    },
  },
  data(){
    return {
      Messages: [],
      UserPrompt: '',
      IsLoggedIn: false,
      ShowAccountReg: false,
      IsWaitingForAI: false,
      IsDev: process.env.VUE_APP_ENV === 'development',
      RegistrationResponse: '',
      RegistrationSuccess: false,
    }
  }
}
</script>

<style>
#app, body, html {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
}

.Transition
{
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
}

.Disabled
{
  background-color: gray !important;
  cursor: default !important; 
}

#Wrapper
{
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
  height: 100%;
}

#AppLogo
{

}

#InputContainer
{
  display: flex;
  margin-bottom: 15px;

  input{
    flex: 1;
    margin-left: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    line-height: 1.42;
    font-size: 20px;
    padding-left: 5px;
  }
}

.Button
{
  border-radius: 10px;
  background-color: #4ea883;
  color: #fff;
  padding: 5px 10px;
  cursor: pointer;
  display: inline-block;
}

.Button:hover
{
  background-color: #63be98;
}

#AccountReg
{
  position: absolute;
  left: 0px;
  top: 0px;
}

#LogoutBtn
{
  background-color: red;
  color: white;
  border-radius: 10px;
  display: inline-block;
  padding: 5px 10px;
  cursor: pointer;
}


.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid currentColor;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}

#AppInfo
{
  background-color: yellow;
  font-weight: bold;
  padding: 4px;
}

.NewUserSuccess
{
  color: green;
}

.NewUserFail
{
  color: red;
}

#SendFeedbackInfo
{
  padding: 15px 30px;
  background-color: bisque;
  position: absolute;
  border-radius: 10px;
  text-align: center;
  font-weight: bold;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #cea27c;
  opacity: 0;
}
</style>
